import { render, staticRenderFns } from "./org-freezer.vue?vue&type=template&id=610d20fa&scoped=true&"
import script from "./org-freezer.vue?vue&type=script&lang=js&"
export * from "./org-freezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d20fa",
  null
  
)

export default component.exports